import React, { Component } from "react";
import {
  TextField,
  Paper,
  AppBar,
  Card,
  FlatButton,
  Divider,
  CardTitle,
  Button,
  IconButton,
  DeleteIcon,
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
} from "material-ui";
import Loading from "../Loading";
import Formsy from "formsy-react";
import { FormsyAutoComplete } from "formsy-material-ui/lib";
import AddCompany from "./AddCompany";
import { Link } from "react-router";
import deleteDefaultIcon from "../../images/delete_default.png";
import backIcon from "../../images/back.png";
import editDefaultIcon from "../../images/edit_default.png";
import importDefaultIcon from "../../images/import_default.png";
import searchIcon from "../../images/search.png";

export default class CompanyIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      isLoading: true,
      openCmp: false,
      company: {},
      searchValue: "",
      searchTextValue: "",
    };
    this.renderTable = this.renderTable.bind(this);
    this.submitSearchForm = this.submitSearchForm.bind(this);
    this.editCompany = this.editCompany.bind(this);
  }

  componentDidMount() {
    this.getAllCompanies();
  }

  getAllCompanies = () => {
    console.log("getAllCompanies");
    let url = `/api/payroll/getAllCompanies`;
    let options = {
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isLoading: false, companies: json.companies });
      });
  };

  deleteCompany = (row) => {
    var me = this;
    let url = `/api/payroll/deleteCompany/${row._id}`;
    let options = {
      method: "delete",
      headers: {
        token: this.props.token.jwt,
      },
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) {
          me.getAllCompanies();
        }
      })
      .then((json) => {
        this.setState({ isLoading: false });
      });
  };

  editCompany = (row) => {
    console.log("row--------", row);
    this.setState({ company: row, openCmp: true });
    console.log("state--------", this.state);
  };

  clearCompanyData = () => {
    this.setState({ company: {} });
  };

  generate = (element) => {
    return [0, 1, 2].map((value) =>
      React.cloneElement(element, {
        key: value,
      }),
    );
  };

  reloadGetAllCompanies = () => {
    console.log("reloadGetAllCompanies");
    window.location.href = "/company/CompanyIndex";
  };

  renderTable() {
    if (this.state.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let filter = { type: "TextFilter", delay: 500 };
      let { companies } = this.state;

      return (
        <div>
          <Table aria-label="customized table">
            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
              <TableRow className="companyListTableHeader">
                <TableHeaderColumn>Company Id</TableHeaderColumn>
                <TableHeaderColumn align="right">
                  Company Name
                </TableHeaderColumn>
                <TableHeaderColumn align="right">Address</TableHeaderColumn>
                <TableHeaderColumn align="right">
                  Contact Number
                </TableHeaderColumn>
                <TableHeaderColumn align="right">Action</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {companies.map((row) => (
                <TableRow key={row._id}>
                  <TableRowColumn>{row.companyId}</TableRowColumn>
                  <TableRowColumn>{row.company}</TableRowColumn>
                  <TableRowColumn>{row.address}</TableRowColumn>
                  <TableRowColumn>{row.contactNumber}</TableRowColumn>
                  <TableRowColumn>
                    <IconButton
                      aria-label="edit"
                      onClick={() => {
                        this.editCompany(row);
                      }}
                      style={{ width: "25px" }}
                    >
                      <img src={editDefaultIcon} />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      onClick={() => {
                        this.deleteCompany(row);
                      }}
                      style={{ width: "25px" }}
                    >
                      <img src={deleteDefaultIcon} />
                    </IconButton>
                    <IconButton
                      aria-label="import"
                      onClick={this.props.performRoute.bind(
                        this,
                        "/company/AddEmployee/" + row._id,
                      )}
                      style={{ width: "25px" }}
                    >
                      <img src={importDefaultIcon} />
                    </IconButton>
                  </TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }
  }

  showAddCompany = () => {
    this.setState({ openCmp: true, company: {} });
  };

  // This method is used for searching
  submitSearchForm(searchText) {
    var me = this;
    if (searchText != "" && searchText != null) {
      let url = `/api/payroll/getSearchedCompany?searchText=${searchText}`;
      let options = {
        method: "GET",
        headers: {
          token: this.props.token.jwt,
        },
      };
      fetch(url, options)
        .then((res) => {
          if (res.status >= 200 && res.status < 300) return res.json();
        })
        .then((json) => {
          this.setState({
            isLoading: false,
            companies: json.companies,
            searchTextValue: searchText,
          });
        });
    } else {
      this.setState({ searchTextValue: "" });
      this.getAllCompanies();
    }
  }

  clearSearchText = () => {
    this.setState({ searchTextValue: "", openCmp: false });
    this.getAllCompanies();
  };

  closeAddCompanyPopup = () => {
    console.log("inside close");
    this.setState({ openCmp: false });
    window.location.href = "/company/CompanyIndex";
  };

  render() {
    return (
      <div className="containerbody">
        <div className="companyContainer">
          <div className="companyListHeader">
            <div style={{ display: "inline-block" }}>
              <Link to="/job/payroll/PayrollInput">
                <img
                  src={backIcon}
                  style={{
                    width: "16px",
                    marginRight: "5px",
                    marginTop: "-5px",
                  }}
                />
              </Link>
            </div>
            <div className="companyListText">
              <div>Company List</div>
            </div>
            <div className="addButtonCls">
              <FlatButton
                onClick={this.showAddCompany}
                className="addFlatButtonCls"
              >
                Add Company
              </FlatButton>
            </div>
          </div>
          <div>
            <div className="searchTextCls">
              <input
                type="text"
                value={this.state.searchTextValue}
                className="searchInputCls"
                placeholder="Search"
                onChange={(e) => this.submitSearchForm(e.target.value)}
              />
              <span
                className="searchImgCls"
                onClick={() => {
                  this.clearSearchText();
                }}
              >
                <img src={searchIcon} style={{ width: "16px" }} />
              </span>
            </div>
          </div>
          {this.renderTable()}
        </div>
        <AddCompany
          open={this.state.openCmp}
          token={this.props.token}
          company={this.state.company}
          clearCompanyData={() => this.clearCompanyData}
          reloadGetAllCompanies={this.reloadGetAllCompanies}
          closeAddCompanyPopup={this.closeAddCompanyPopup}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/companies/CompanyIndex.js